import type { NotificationSettingsState } from './notification-settings-selectors';
import { SUCCESS, STARTING, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByParam } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState = {
  notificationSettingsById: {},
  notificationSettingsStateByParams: {},
};

export const notificationSettingsReducer = (
  state: NotificationSettingsState = InitialState,
  action: Action,
): NotificationSettingsState => {
  switch (action.type) {
    case STARTING('LOAD_NOTIFICATION_SETTINGS'): {
      const { params } = action.payload.args;
      return updateResourceByParam(
        state,
        'notificationSettings',
        'params',
        JSON.stringify(params),
        true,
      );
    }
    case SUCCESS('LOAD_NOTIFICATION_SETTINGS'): {
      const { params } = action.payload.args;
      const { data } = action.payload;
      return updateResourceByParam(
        state,
        'notificationSettings',
        'params',
        JSON.stringify(params),
        false,
        convertArrayToMap(data, (ns: NotificationSetting) => String(ns.notificationSettingId)),
      );
    }
    case FAILURE('LOAD_NOTIFICATION_SETTINGS'): {
      const { params } = action.payload.args;
      return updateResourceByParam(
        state,
        'notificationSettings',
        'params',
        JSON.stringify(params),
        false,
      );
    }
    case SUCCESS('CREATE_NOTIFICATION_SETTINGS'): {
      const { result } = action.payload.data;
      return {
        ...state,
        notificationSettingsById: {
          ...state.notificationSettingsById,
          [result.notificationSettingId]: result,
        },
      };
    }
    case SUCCESS('DELETE_NOTIFICATION_SETTINGS'): {
      const { notificationSettingId } = action.payload.args;
      // Because we delete the actual data entry in NotificationSettings, set the value of the key-value pair to null
      // In an ideal world, we would create an isOn column that would update this information.
      const newNotificationSettingsById = { ...state.notificationSettingsById };
      delete newNotificationSettingsById[notificationSettingId];
      return {
        ...state,
        notificationSettingsById: newNotificationSettingsById,
      };
    }
    default:
      return state;
  }
};
